// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Ir0Uc","loadingWrap":"styles_loadingWrap__nmt6v","noData":"styles_noData__PDKIq","noDataIcon":"styles_noDataIcon__Ar6V+"};